<template>
<div>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-subtitle>
        <v-icon class="mr-1">date_range</v-icon>
        {{ caption }}
      </v-list-item-subtitle>
      <v-list-item-title>{{ dateUpdate === '' ? '...' : dateUpdate }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn icon text class="pa-0 ma-0" @click="dialog = !dialog">
        <v-icon v-if="dateUpdate !== ''" color="editicon">edit</v-icon>
        <v-icon v-else color="editicon">add</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
  <v-dialog
    v-model="dialog"
    max-width="500"
    scrollable>
    <v-card>
      <v-toolbar class="elevation-0 white--text mb-3" color="primary">
        <v-toolbar-title>Edit {{ caption }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="dialog = false" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-date-picker
          full-width
          class="mb-3 grey lighten-4 black--text"
          v-model="dateUpdate"
          :max="new Date().toISOString().substr(0, 10)">
        </v-date-picker>
      </v-card-text>
      <div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text class="mx-3 mb-2" @click="cancelEdit()">CANCEL</v-btn>
          <v-btn text class="mx-3 mb-2" :disabled="!enableSave" @click="updateAttribute()" color="primary">SAVE</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
export default {
  props: {
    caption: String,
    date: String
  },
  data: function () {
    return {
      dialog: false,
      dateUpdate: '',
      fullscreen: true,
      enableSave: false
    }
  },
  methods: {
    cancelEdit: function () {
      this.dateUpdate = JSON.parse(JSON.stringify(this.date))
      this.dialog = false
    },
    updateAttribute: function () {
      this.$emit('update', this.dateUpdate)
      this.enableSave = false
      this.dialog = false
    },
    setHeaders (param) {
      if (param === 'xs') {
        this.fullscreen = true
      } else {
        this.fullscreen = false
      }
    }
  },
  computed: {
    dateUp: function () {
      return this.dateUpdate
    },
    dateProp: function () {
      return this.date
    },
    breakpoint () {
      return this.$vuetify.breakpoint.name
    }
  },
  watch: {
    dateUp: function () {
      if (this.dateUpdate !== this.date) {
        this.enableSave = true
      } else {
        this.enableSave = false
      }
    },
    dateProp: function () {
      this.dateUpdate = JSON.parse(JSON.stringify(this.date))
    },
    breakpoint () {
      this.setHeaders(this.breakpoint)
    }
  },
  created () {
    this.dateUpdate = JSON.parse(JSON.stringify(this.date))
    this.setHeaders(this.breakpoint)
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile/datefield.vue